// Dev-only diagnostics. No-ops in production builds so nothing is logged or
// leaked to end users, while still surfacing swallowed errors while developing.
export function logError(context, error) {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.debug(`[yaprio] ${context}`, error);
  }
}
